export default {
	title: 'ステークホルダー',
	context_best: '好意的',
	context_worse: '敵対的',
	zones: {
		positive: '好意的',
		positive_line2: 'ゾーン',
		neutral: '中立',
		negative: '敵対的',
		negative_line2: 'ゾーン',
		point_of_view_line1: '視',
		point_of_view_line2: '点',
		point_of_view_line3: ''
	},
	alignment: {
		title_1: 'ステークホルダー',
		title_2: 'アライメント'
	},
	tabs: {
		general: {
			title: '一般'
		},
		links: {
			title: 'リンク'
		},
		comments: {
			title: '履歴'
		},
		filters: {
			title: '表示フィルター'
		},
		export: {
			title: 'エクスポート',
			image: 'レーダーを画像としてエクスポート'
		},
		risks: {
			title: 'リスク'
		},
		bot: {
			title: 'AI'
		},
		tags: {
			title: 'タグ',
			assigned: '割り当て済みタグ',
			unassigned: '未割り当てタグ'
		},
		disabled: {
			title: '無効'
		}
	},
	summary: {
		key_drivers: '主要ドライバー',
		scenario_score: 'シナリオスコア',
		max_value: '最大 {{value}}',
		legend: {
			current: '現在',
			scenario: 'シナリオ'
		}
	},
	all_tags: 'タグで絞り込み',
	links: 'すべてのリンクを表示',
	no_tag: 'タグなし',

	all_icons: 'アイコンで絞り込み',
	no_icon: 'アイコンなし',

	all_stakes: 'ステークで絞り込み',
	all_constraints: '指標で絞り込み',
	all_risks: 'リスクで絞り込み',
	all_opportunities: '突破口で絞り込み',
	onboarding: {
		title: 'ステークホルダーの確認',
		description:
			'あなたのテーマに影響を与えるアクターは、影響力とスタンスに基づいてレーダー上に配置されています。アライメントを確認し、見解が異なる場合は調整してください。'
	}
};
